import React from 'react'
import SubscriptionTable from '../subscription-table'
import { useIsAuthenticated } from '../../hooks/use-is-authenticated'

/**
 * Permanently deprecate the usage of the 5 grid component
 * use this component as a subscription price table placeholder without actually rendering the 5 grid,
 * so whenever we see GRID / PROMO GRID component in admin console, it means a subscription price table.
 */
const PromotionalGrid = () => {
  const isAuthenticated = useIsAuthenticated()

  return isAuthenticated ? null : <SubscriptionTable />
}

export default PromotionalGrid
